<template>
  <Teleport to="body">
    <div v-if="visible" class="nh-overlay" :style="{ zIndex }" @click.self="$emit('close')">
      <Transition name="nh-slide">
        <div v-if="visible" class="nh-panel">
          <div class="nh-header d-flex align-items-center justify-content-between px-3 py-2 border-bottom">
            <h6 class="mb-0 fw-bold">Histórico de Notificações</h6>
            <button class="btn btn-sm btn-link text-secondary p-0" @click="$emit('close')" title="Fechar">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>
          <div class="nh-body px-3 py-2">
            <div v-if="notificationsHistory.length === 0" class="text-center text-muted py-4">
              <i class="bi bi-inbox fs-2 d-block mb-2"></i>
              <span>Nenhuma notificação recente.</span>
            </div>
            <div v-for="notification in notificationsHistory" :key="notification.id" class="nh-item d-flex align-items-start py-2 border-bottom">
              <i :class="['bi', getHistoryIconClass(notification.type), 'me-2', 'mt-1', 'flex-shrink-0']"></i>
              <div class="text-wrap">
                <strong class="me-1">{{ notification.timestamp }}</strong>
                <span>{{ notification.message }}</span>
              </div>
            </div>
          </div>
        </div>
      </Transition>
    </div>
  </Teleport>
</template>

<script>
import { reservarZIndex, liberarZIndex, BASE_ZINDEX } from '@/composables/useZIndex'

export default {
  name: 'NotificationHistoryModal',
  props: {
    visible: { type: Boolean, default: false },
    notificationsHistory: { type: Array, default: () => [] }
  },
  emits: ['close'],
  data () {
    return {
      // --- Empilhamento (z-index) via registry central ---
      zIndex: BASE_ZINDEX,
      tokenZIndex: null
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler (novoValor) {
        if (novoValor) {
          const { token, zIndex } = reservarZIndex()
          this.tokenZIndex = token
          this.zIndex = zIndex
        } else {
          liberarZIndex(this.tokenZIndex)
          this.tokenZIndex = null
        }
      }
    }
  },
  beforeUnmount () {
    liberarZIndex(this.tokenZIndex)
    this.tokenZIndex = null
  },
  methods: {
    getHistoryIconClass (type) {
      switch (type) {
        case 'success': return 'bi-check-circle text-success'
        case 'error': return 'bi-x-circle text-danger'
        case 'warning': return 'bi-exclamation-triangle text-warning'
        default: return 'bi-info-circle text-info'
      }
    }
  }
}
</script>

<style scoped>
/* ========================
   OVERLAY
   ======================== */
.nh-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

/* ========================
   PANEL (mobile: bottom sheet)
   ======================== */
.nh-panel {
  width: 100%;
  max-height: 80vh;
  background-color: var(--bs-body-bg);
  color: var(--bs-body-color);
  border-radius: 1rem 1rem 0 0;
  display: flex;
  flex-direction: column;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
}

.nh-header {
  flex-shrink: 0;
  border-bottom-color: var(--bs-border-color-translucent) !important;
}

.nh-body {
  overflow-y: auto;
  flex-grow: 1;
  min-height: 0;
}

.nh-item {
  font-size: 0.85rem;
  border-bottom-color: var(--bs-border-color-translucent) !important;
}

.nh-item:last-child {
  border-bottom: none !important;
}

/* ========================
   TRANSIÇÃO DE ENTRADA/SAÍDA
   ======================== */
.nh-slide-enter-active {
  transition: transform 0.3s ease;
}

.nh-slide-leave-active {
  transition: transform 0.2s ease;
}

.nh-slide-enter-from {
  transform: translateY(100%);
}

.nh-slide-leave-to {
  transform: translateY(100%);
}

/* ========================
   DESKTOP / TABLET (>=768px)
   ======================== */
@media (min-width: 768px) {
  .nh-overlay {
    align-items: center;
  }

  .nh-panel {
    max-width: 520px;
    width: 100%;
    border-radius: 1rem;
    max-height: 70vh;
    margin: 1rem;
  }

  .nh-slide-enter-active {
    transition: transform 0.3s ease, opacity 0.3s ease;
  }

  .nh-slide-leave-active {
    transition: transform 0.2s ease, opacity 0.2s ease;
  }

  .nh-slide-enter-from {
    transform: translateY(24px) scale(0.97);
    opacity: 0;
  }

  .nh-slide-leave-to {
    transform: translateY(24px) scale(0.97);
    opacity: 0;
  }
}

/* ========================
   MODO ESCURO
   ======================== */
[data-bs-theme="dark"] .nh-panel {
  background-color: var(--bs-body-bg);
  border: 1px solid var(--bs-border-color-translucent);
}

[data-bs-theme="dark"] .nh-header {
  border-bottom-color: var(--bs-border-color-translucent) !important;
}
</style>
